import React, {Component} from "react";  import config from 'react-global-configuration';
import axios from "axios";
import {Input} from 'reactstrap';
import jwt_decode from 'jwt-decode';
import {Link, Redirect} from "react-router-dom";
import SimpleReactValidator from 'simple-react-validator';
import Cookies from 'universal-cookie';
import {BeatLoader} from 'react-spinners';
import {css} from "@emotion/core";
import Countdown from 'react-countdown';
import invLogo from "../assets/img/innoviti-logo.png";
import GoogleLogin from 'react-google-login';
import {isMobile} from "react-device-detect";
import leftBackImg from "../assets/img/landing_back.png";
import $ from "jquery";
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    color: white;
    text-align:center;
`;
class AuthPage extends Component {

   constructor() {
      super();
      const token = localStorage.usertoken;
      let loggedIn = true;
      if(token == null){
         loggedIn = false;
      }

      this.state = {
        email: '',
        password: '',
        errors:'',
        max_attempt_error:'',
        OTP: false,
        OTPVal:'',
        uArray:[],
        loading:false,
        mobile:'',
        loggedIn,
        countdown: '',
        login_view: 'client'

   };
      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.validator = new SimpleReactValidator();
      this.validator1 = new SimpleReactValidator();
   }
   componentDidMount() {
       //console.log(config.get('API_URL'));
       const cookies = new Cookies();
       var uArray = cookies.get('userDetails');
       if(cookies.get('userDetails')!==undefined) {
           this.setState({
               uArray: uArray
           })
       }

   }
    onChangeOTP(e){
        this.setState({
            OTPVal: e.target.value
        })
    }

    onChange(e) {
      this.setState({ [e.target.name]: e.target.value });
       //console.log(this.state);
   }

   onSubmit(e) {
       e.preventDefault();

       this.setState({
           loading: true,
           errors:'',
           max_attempt_error:''
       });
       const user = {
       email: this.state.email,
       password: this.state.password
       };

       let validate ='';
       if(this.state.OTP===false) {
           validate = this.validator.allValid();
       }
       else {
           validate = this.validator1.allValid();
       }

       // alert(user.email+','+user.password+','+this.state.OTPVal+','+this.state.uArray)

       if (validate) {
           axios.post(config.get('API_URL')+'/users/login', {
               email: user.email.trim(),
               password: user.password,
               otp: this.state.OTPVal,
               uArray : this.state.uArray
           })
           .then(response => { //console.log("gdfgdfg"); console.log(response.data.responseDetails.requestType);
               if(response.data.responseMessage == 'Invalid Parameters') {
                   this.setState({
                       errors: "Invalid Parameters",
                       loading: false
                   });
                   return false;
               }
               if(response.data.responseDetails.requestType == 'GENERATE_OTP') {
                   this.setState({
                       OTP: true,
                       loading: false,
                       mobile: response.data.responseDetails.mobileNumber,
                       countdown:Date.now()
                   })
               }
               else if(response.data.responseDetails.requestType == 'Error') {
                       console.log("error");
                       this.setState({
                           errors: response.data.responseDetails.error,
                           max_attempt_error: response.data.responseDetails.max_attempt_err,
                           loading: false
                       })
                   } else if(response.data.responseDetails.requestType == 'Login') {

                       localStorage.setItem('usertoken', response.data.responseDetails.data);
                       localStorage.setItem('userPermission', response.data.responseDetails.user_permissions);
                       const token = localStorage.usertoken;
                       const permissionToken = localStorage.userPermission;
                       const decoded = jwt_decode(token);
                       const decodedPermission = jwt_decode(permissionToken);
                       console.log(decoded);
                       this.setState({
                           loggedIn: true,
                           loading: false
                       });
                       if(decoded.object_type==='Merchant' || decoded.object_type==='Chain' || decoded.object_type==='Store' || decoded.object_type==='Innoviti')
                       {
                            this._get_column_mapping(decoded.object_type, decoded.object_code);
                       } else {
                             localStorage.removeItem("is_extra_column");
                             localStorage.removeItem("extra_columns");
                             localStorage.removeItem("extra_columns_query");
                             localStorage.removeItem("extra_columns_merchant");
                       }
                       if(decoded.warehouse_id || decoded.userType=='Internal'){
                         this.salesforceAuthToken();
                       }
                       if(decoded.userGroupName==='Meta Users')
                       {
                            this.get_state_code(decoded._id);
                       } else {
                            localStorage.removeItem("state_code");
                       }


                       return response.data
                   }

           })
           .catch(err => {
               //console.log(err);
               //console.log(err.error);
               localStorage.removeItem("usertoken");
               localStorage.removeItem("userPermission");
				localStorage.removeItem("MenuList");

           })
       } else {
           this.validator.showMessages();
           this.validator1.showMessages();
           // rerender to show messages for the first time
           // you can use the autoForceUpdate option to do this automatically`
           this.forceUpdate();
           this.setState({
               loading: false
           });
       }
   }
    googleLogin(response) {
        console.log(response.profileObj.email);
        axios.post(config.get('API_URL')+'/users/google_login', {
            email: response.profileObj.email
        })
            .then(response => {

                if (response.data.error) {
                    console.log("error");
                    this.setState({
                        errors: response.data.error
                    })
                } else {
                    console.log("sucess");

                    localStorage.setItem('usertoken', response.data.data);
                    localStorage.setItem('userPermission', response.data.user_permissions);
                    const token = localStorage.usertoken;
                    const permissionToken = localStorage.userPermission;
                    const decoded = jwt_decode(token);
                    const decodedPermission = jwt_decode(permissionToken);
                    this._get_column_mapping(decoded.object_type, decoded.object_code);
                    if(decoded.userSubGroupName == 'Admin' || decoded.user_admin_access===true){
                         this.salesforceAuthToken();
                    }
//                     console.log("after")
                    this.setState({
                        loggedIn: true,
                    });

                    return response.data
                }


            })
            .catch(err => {
                console.log(err);
                console.log(err.error);
                localStorage.removeItem("usertoken");
                localStorage.removeItem("userPermission");
            })
    }
    login_view(view, e){
       //alert(view);
       this.setState({
           login_view:view,
           max_attempt_error:'',
           errors:''
       })
   }


    salesforceAuthToken(){
      axios.get(config.get('API_URL')+'/inventory/auth/token',{
        headers: {
            Authorization: ` ${localStorage.usertoken}`
        }
      }).then(response => {
        localStorage.setItem('salesforce_token', response.data.access_token);
      }).catch(error => {
          console.log(error.response);
      });
    }
    _get_column_mapping(object_type, object_code)
    {
       let arrayCode = object_code.split(",");
       axios.post(config.get('API_URL')+'/filters/get-column-mapping/', {
            object_type:object_type,
            object_code:arrayCode
       },
       {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {

            if(response.data.is_extra_column==='yes'){
                localStorage.setItem('is_extra_column', 'yes');
                localStorage.setItem('extra_columns', response.data.data.extra_columns);
                localStorage.setItem('extra_columns_query', response.data.data.filter_query);
                localStorage.setItem('extra_columns_merchant', response.data.data.merchant_code);
            } else {
                localStorage.removeItem("is_extra_column");
                localStorage.removeItem("extra_columns");
                localStorage.removeItem("extra_columns_query");
                localStorage.removeItem("extra_columns_merchant");
            }

            this.setState({
                loading:false,
            });
            //tableau_token: response.data.credentials.token
        }).catch(error => {
          console.log(error);
          localStorage.removeItem("is_extra_column");
          localStorage.removeItem("extra_columns");
          localStorage.removeItem("extra_columns_query");
          localStorage.removeItem("extra_columns_merchant");
        });
    }

    get_state_code(user_id)
    {
       //let arrayCode = object_code.split(",");
       axios.post(config.get('API_URL')+'/filters/get-state-code/', {
            user_id:user_id,
       },
       {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
           console.log("hhgghg");
           console.log(response.data.state_code);
           localStorage.setItem('state_code', response.data.state_code);

        }).catch(error => {
          console.log(error);
          localStorage.removeItem("state_code");

        });
    }

    render() {
        const Completionist = () => <span className="otpError">OTP has been expired!</span>;
        const renderer = ({ hours, minutes, seconds, completed }) => {
            if (completed) {
                // Render a completed state
                return <Completionist />;
            } else {
                // Render a countdown
                return <span>{hours}:{minutes}:{seconds}</span>;
            }
        };
       if(this.state.loggedIn === true  && !isMobile){
         return <Redirect to ="/admin/home-page"/>
       }
       else if (this.state.loggedIn === true && isMobile){
           return <Redirect to="/admin/Innoviti-Support-Modes"/>
     }

        const responseGoogle = (response) => {
            // console.log("google console");
            // console.log(response);
            if(response.error){
                // this.setState({
                //     errors: response.error
                // })
            } else {
                this.googleLogin(response);
            }
        };
        const leftBackground = {
            backgroundImage: "url(" + leftBackImg + ")"
        };
        var client_selected = 'client-login-tab';
        var inno_selected = 'inno-login-tab';
        if(this.state.login_view=='client') {
            client_selected = 'client-login-tab selected-login-tab';
            inno_selected = 'inno-login-tab';
        } else if(this.state.login_view=='innoviti') {
            client_selected = 'client-login-tab';
            inno_selected = 'inno-login-tab selected-login-tab';
        }
      return (
         <div className = "authFrom">
             <div className="col-md-6 col-sm-12 no-padd auth-left-background" style={leftBackground}>
                <div className="welcome-text">
                    <h2>Welcome to Sparcs</h2>
                    <h5>Please login to your account</h5>
                </div>
             </div>
            <div className="col-md-6 col-sm-12 no-padd auth-right-background">
                {/*<h2 className="text-center authheading">*/}
                {/*    <img src={invLogo} alt={invLogo} className="" />*/}
                {/*</h2>*/}
               <div className="login-card">
                   <div className="welcome-text-mobile">
                       <h3>Welcome to Sparcs</h3>
                       <h5>Please login to your account</h5>
                   </div>

                   <a href="#" className={inno_selected} onClick={this.login_view.bind(this, 'innoviti')}>Innoviti Login</a>
                   <a href="#" className={client_selected} onClick={this.login_view.bind(this, 'client')}>Client Login</a>
                   <div className="clearfix"></div>
                  <form className="auth" method="POST" onSubmit={this.onSubmit}>
                      {this.state.login_view=='client'?
                          <React.Fragment>
                     <div className="form-group">

                        <i className="fa fa-envelope-o"></i>
                        <Input placeholder="Enter Email/Mobile number" name="email" type="text" className="logon-input"  value={this.state.email} onChange={this.onChange} />
                        {this.validator.message('email/mobile number', this.state.email, 'required')}
                     </div>
                     <div className="form-group">

                        <i className="fa fa-lock"></i>
                        <Input placeholder="Enter your password" name="password" type="password" className="logon-input" value={this.state.password} onChange={this.onChange}/>
                        {this.validator.message('password', this.state.password, 'required')}
                     </div>

                      {this.state.OTP===true?
                          <div className="form-group">
                              <div className="">
                                <i className="fa fa-key" aria-hidden="true"></i>
                                <Input placeholder="Enter OTP" name="otp" type="text" className="logon-input OTP-Text"  value={this.state.OTPVal} onChange={this.onChangeOTP.bind(this)} />
                              </div>
                              <div className="col-xs-12">
                                  <Countdown
                                      date={this.state.countdown + 300000}
                                      renderer={renderer}
                                  />
                              </div>

                              <div className="col-xs-12">
                              <small className="otpMessage text-muted">A SMS verification code send to your register mobile number ******{this.state.mobile.substr(-4)} please verify your account.</small>
                              </div>
                              <div className="clearfix"></div>

                              {this.validator1.message('One Time Password', this.state.OTPVal, 'required')}
                              {/*<div className="otpMessage">A SMS varification code send to your register mobile number ******{this.state.mobile.substr(-4)} please verify your account.</div>*/}
                          </div>

                          : null  }
                     {/*
                     <div className="form-check"><Label className="form-check-Label "><input type="checkbox" className="form-check-input"/> Remember me</Label></div>
                     */}
                    <div className="form-group">
                        <div><span className ="errmsg">{this.state.errors}</span></div>
                        <div><span className ="errmsg">{this.state.max_attempt_error}</span></div>
                        <div className="forgot-pass">
                            <Link to="/admin/forgot-password">Forgot Password?</Link>
                        </div>
                      {this.state.OTP===true?
                          <button
                              type="submit"
                              className="btn btn-lg btn-login"
                          >
                              Verify & Sign in
                          </button>:
                          <React.Fragment>
                     <button
                        type="submit"
                        className="btn btn-lg btn-login"
                        >
                     Login
                     </button>
                              <button disabled="true"
                                          type="button"
                                  className="btn btn-lg btn-register"
                                      title = "Functionality under development"
                              >
                                  Register
                              </button>

                          </React.Fragment>}
                    </div>
                      <br/>
                      <BeatLoader
                          css={override}
                          sizeUnit={"px"}
                          size={15}
                          color={'#123abc'}
                          loading={this.state.loading}
                      />
                          </React.Fragment>
                          :

                      <div className="text-center pt-1">
                          <br/>
                         <GoogleLogin
                             clientId="497260790478-uepp9iiof24mj3bu6r5f7mt9eer553e5.apps.googleusercontent.com"
                             render={renderProps => (
                                 <button className="btn-social btn-google" onClick={renderProps.onClick} disabled={renderProps.disabled}>
                                     <span className="fa fa-google"></span>&nbsp;Login with Google</button>
                             )}
                             buttonText="Login with Google"
                             onSuccess={responseGoogle}
                             onFailure={responseGoogle}/>
                             <br/><br/>
                          <div><span className ="errmsg">{this.state.errors}</span></div>
                     </div> }
                  </form>
               </div>
            </div>
            <div className="clearfix"></div>
         </div>


      );
    }
  }

  export default AuthPage;
